export enum LangNamespaceEnum {
  SHARED = 'shared',
  SURVEY_UI_COMMON = 'surveyUICommon',
  SURVEY_UI_COMPONENTS = 'surveyUIComponents',
  SURVEY_UI_PAGES = 'surveyUIPages',
  SURVEY_UI_STORIES = 'surveyUIStories',
  SURVEY_UI_HOOKS = 'surveyUIHooks',
}
